import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../helper/apiCall";
import ENDPOINTS from "../../constants/endpoints";

const initialState = {
    loading: false,
};


export const getFinance = createAsyncThunk(
    "getFinance",
    async (params, thunkAPI) => {
        try {
            const placeQuery = params.placeId ? "&PlaceId=" + params.placeId : "";
            const response = await client.get(ENDPOINTS.FINANCE.GET_LIST + "?StartDate=" + params.startDate + "&EndDate=" + params.endDate + "&BranchId=" + params.branchId + placeQuery, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    });

export const addFinance = createAsyncThunk(
    "addFinance",
    async (body, thunkAPI) => {
        try {
            const response = await client.post(ENDPOINTS.FINANCE.ADD, body, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    });


const financeSlice = createSlice({
    name: "finance",
    initialState,
    reducers: {

    },
    extraReducers(builder) {
        builder.addCase(getFinance.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getFinance.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(getFinance.rejected, (state, action) => {
            state.loading = false;
        });
        builder.addCase(addFinance.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(addFinance.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(addFinance.rejected, (state, action) => {
            state.loading = false;
        });

    },
});

export default financeSlice.reducer;
